import {HttpClient, HttpEvent} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FileUploadRepository} from '../../core/repository/file-upload-repository'; // NOSONAR
import {DataStorageService} from 'shared/services/data-storage.service';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService extends FileUploadRepository {
  public progress: number;
  public message: string;

  constructor(
    httpClient: HttpClient,
    private readonly storage: DataStorageService
  ) {
    super(httpClient);
  }

  upload(file: any, language: string, isForModule2: boolean): Observable<any> {
    if (file.size === 0) {
      return null;
    }

    const formData = new FormData();
    formData.append(file.name, file);

    return this.getDataInputFromImportFile(formData, language, isForModule2);
  }

  downloadinputdatatemplate(currentLang: string): Observable<HttpEvent<Blob>> {
    return this.download(currentLang);
  }

  async exportExcelAnalyseData<T>(
    dataInput: T,
    currentLang: string,
    sender: string
  ): Promise<Observable<HttpEvent<Blob>>> {
    const isKontrollmodus = await this.storage.getKontrollmodus();
    return this.getExportExcelAnalyseData(
      dataInput,
      currentLang,
      sender,
      isKontrollmodus
    );
  }
}
